import * as api from 'api/prescreen';

export const fetchPrescreenQuestions = params => ({
  type: 'FETCH_PRESCREEN_QUESTIONS',
  payload: api.fetchPrescreenQuestions(params),
});

export const fetchPrescreenInstance = id => ({
  type: 'FETCH_PRESCREEN_QUESTIONS_INSTANCE',
  payload: api.fetchPrescreenInstance(id),
});

export const fetchActivePrescreenQuestions = params => ({
  type: 'FETCH_ACTIVE_PRESCREEN_QUESTIONS',
  payload: api.fetchPrescreenQuestions(params),
});

export const fetchArchivedPrescreenQuestions = params => ({
  type: 'FETCH_ARCHIVED_PRESCREEN_QUESTIONS',
  payload: api.fetchPrescreenQuestions(params),
});
